const updates = [
  { date: '2026.07.31', title: '《藏海花》更新至第28集，剧情进入高潮阶段', tag: '剧集更新' },
  { date: '2026.07.30', title: '《唐朝诡事录之西行》全36集已更新完毕', tag: '全集上线' },
  { date: '2026.07.29', title: '院线大片《第二十条》高清版全网首发上线', tag: '新片首发' },
  { date: '2026.07.28', title: '综艺《歌手2024》第10期舞台纯享版上线', tag: '综艺更新' },
  { date: '2026.07.27', title: '平台播放引擎升级，加载速度提升40%', tag: '系统优化' },
  { date: '2026.07.26', title: '新增纪录片《地球脉动3》全系列中配版', tag: '内容上新' },
  { date: '2026.07.25', title: '《长相思第二季》超前点播已更新至第32集', tag: '剧集更新' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">最新动态</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            影视更新快讯、平台功能升级、新内容上线，第一时间掌握番茄影视最新资讯
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-5 md:left-6 top-0 bottom-0 w-px bg-background-200"></div>
          <div className="flex flex-col gap-6 md:gap-8">
            {updates.map((item, i) => (
              <div key={i} className="relative flex items-start gap-5 md:gap-6 pl-12 md:pl-14">
                <div className="absolute left-0 w-10 h-10 md:w-12 md:h-12 rounded-xl bg-background-100 border-2 border-background-200 flex items-center justify-center flex-shrink-0">
                  {i === 0 ? (
                    <i className="ri-flashlight-line text-primary-500 text-lg"></i>
                  ) : (
                    <div className="w-2 h-2 rounded-full bg-accent-400"></div>
                  )}
                </div>
                <div className="flex-1 min-w-0 pt-1">
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <span className="text-xs text-foreground-500 font-medium">{item.date}</span>
                    <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium">{item.tag}</span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 font-medium">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}